import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import { LeadsBoard } from "@/pages/marketing/MarketingDashboard";

export default function LeadsPage() {
  return <AdminShell><LeadsBoard /></AdminShell>;
}
